/** Local Vite only — unlock every campaign region for playtesting. */
export const shouldUnlockAllRegions = (): boolean =>
  Boolean(import.meta.env.DEV);
